var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.979,
    height: 17.267,
    viewBox: "0 0 18.979 17.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Systems_icon",
    x: 0,
    y: 0,
    width: 18.979,
    height: 17.267,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Systems_icon-2",
    "data-name": "Systems icon",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Systems_icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Systems_icon-3",
    "data-name": "Systems icon",
    d: "M-172.63,371.871v14.217h8.6V371.871Zm3.576,10.561h-1.921v-1.921h1.921Zm0-3.308h-1.921V377.2h1.921Zm0-3.308h-1.921v-1.921h1.921Zm3.321,6.616h-1.921v-1.921h1.921Zm0-3.308h-1.921V377.2h1.921Zm0-3.308h-1.921v-1.921h1.921Zm9.082,2.753v7.57h-2.006v-3.992h-2.994v3.992h-2.006v-7.57Zm0-1.394h-7.006v1.055h7.006Z",
    transform: "translate(174.13 -371.37)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemsicon);
export default __webpack_public_path__ + "static/media/Systems icon.778b04bb4347ccb98babbd13dd9c1deb.svg";
export { ForwardRef as ReactComponent };